import cn from 'classnames';

import BaseModal from '@/components/modal/lib/BaseModal';
import EmailSmsModalForm from '@/components/form/EmailSmsModalForm/EmailSmsModalForm';
import Text from '@/components/common/Text/Text';

import './EmailSmsModal.style.scss';

type EmailSmsModalProps = {
  className?: string;
  onClose: () => void;
};

function EmailSmsModal(props: EmailSmsModalProps) {
  const { className = '', onClose } = props;
  const emailSmsModalDismissedDate = new Date().toDateString();

  return (
    <BaseModal
      className={cn('EmailSmsModal', className)}
      onClose={() => {
        localStorage.setItem(
          'emailSmsModalDismissedDate',
          emailSmsModalDismissedDate
        );
        onClose();
      }}
    >
      <Text
        variant={'title-xl'}
        italic
      >
        Join our list!
      </Text>

      <EmailSmsModalForm
        initialValues={{ email: '', phoneNumber: '', optinText: false }}
        onSubmitSuccess={() => {
          localStorage.setItem(
            'emailSmsModalDismissedDate',
            emailSmsModalDismissedDate
          );
          onClose();
        }}
      />
    </BaseModal>
  );
}

export default EmailSmsModal;
